import React from 'react';

export const CaAuthContext = React.createContext<{
  isAuthenticated: boolean;
  signOut: () => void;
}>({
  isAuthenticated: false,
  signOut: () => {
    throw new Error('signOut function must be implemented in a provider');
  },
});
